/**
 * User: daletan
 * Date: 12/22/14
 * Time: 4:45 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

'use strict';

var $ = require('dibs-jquery-shim');
var indexOf = require('lodash.indexof');
var Backbone = require('dibs-backbone');
var templates = require('../../../templates/global/recent-history');
var tracking = require('dibs-tracking');

var LIST_NAME = 'recent items history';
// duplicate ref in FindingProductTracking
var ECOM_TYPE_CLICK = 'productClick';
var ECOM_TYPE_IMRESSION = 'productImpression';

require('jquery-operator');

module.exports = Backbone.BaseView.extend({
    tagName: 'ul',
    className: 'recent-history-list rowFlexTransition',
    events: {
        'click .recent-history-item': 'trackItemClick'
    },
    initialize: function () {
    },
    trackItemClick: function (e) {
        var $this = $(e.currentTarget);
        var itemIndex = this.getItemIndex(e.currentTarget);
        var eventObj = {
            category: "Results Page Filters and Actions",
            action: "recent history sidebar - click to pdp",
            label: itemIndex
        };
        tracking.trackEvent(eventObj);

        // Tracking for google tag manager productClick
        this.trackEcommerce(ECOM_TYPE_CLICK, this.getTrackProduct($this), LIST_NAME);
    },
    /**
     *
     * @param {string|jQuery object} $el
     * @returns {*}
     */
    getItemTitle: function ($el) {
        var titleCheck = 'at 1stdibs';
        var title = $el;
        if ($el instanceof $) {
            title = $el.attr('title') || $el.find('img').attr('title');
        }
        if (title.indexOf(titleCheck) > -1) {
            title = $.trim(title.split(titleCheck)[0]);
        }
        return title;
    },
    /**
     * tracks the google tag manager ecommerce impression for recent history items
     * @param e
     * @param items
     */
    trackImpression: function () {
        var self = this;
        var $listEl = self.$('.recent-history-item');
        var products = [];
        $.each($listEl, function (index, el) {
            products.push(self.getTrackProduct($(el), LIST_NAME));
        });
        this.trackEcommerce(ECOM_TYPE_IMRESSION, products);
    },
    /**
     * takes a list item (li) and returns an product object for google tag manager to track
     * @param {jQuery} $el
     * @param {string} [list]
     */
    getTrackProduct : function ($el, list) {
        var $anchor = $el.find('.recent-history-link');
        var dealerPk = $anchor.data('dealerpk');
        var name = this.getItemTitle($el);
        var product = {
            url : $anchor.attr('href'),
            position : $el.index() + 1
        };
        if (name) {
            product.name = name;
        }
        if (dealerPk) {
            product.brand = dealerPk;
        }
        if (list) {
            product.list = list;
        }
        return product;
    },
    /**
     * @param {string} type
     * @param {array|object} products
     * @param {string} [list]
     */
    trackEcommerce : function (type, products, list) {
        tracking.trackEcommerce({
            type : type,
            products : Array.isArray(products) ? products : [products],
            actionField : {
                list : list
            }
        });
    },
    getItemIndex: function (item) {
        var items = this.$(".recent-history-item");
        return item ? [indexOf(items, item) + 1, "/", items.length].join("") : 0;
    },
    getImageUrl: function (obj) {
        // switching data to use camelCase properties
        // but there are still under_scored ones
        var ret;
        if (obj) {
            if (obj.itemImageUrl) {
                ret = obj.itemImageUrl.src || obj.itemImageUrl;
            } else if (obj.item_image_url) {
                ret = obj.item_image_url.src || obj.item_image_url;
            }
        }
        return ret;
    },
    formatAttributes: function (attrs) {
        return {
            url: attrs.itemPdpUrl || attrs.item_pdp_url,
            imageUrl: this.getImageUrl(attrs),
            title: attrs.itemTitle || attrs.item_title,
            dealerPk: attrs.dealerPk
        };
    },
    render: function () {
        this.$el.empty();

        this.collection.each(function (model) {
            var attrs = this.formatAttributes(model.toJSON());
            attrs.additionalClasses = 'colXs12 colLg12';

            this.$el.append(templates.tmplRecentHistoryItem(attrs));
        }, this);

        // Tracking for google tag manager productClick
        this.trackImpression();
        return this;
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/modules/recentHistory/RecentHistoryListView.js
// module id = 831
// module chunks = 4 6 8 9 12